<app-tab>

  <dx-text-box stylingMode="filled" (onValueChanged)="searchGrid($event)" placeholder="Recherche...">
    <dxi-button name="icon" location="before"
                [options]="{type: 'text', icon: 'search', disabled: true, elementAttr : {class: 'map-sidebar-search-panel-btn' }}"></dxi-button>
    <dxi-button name="filter" location="after"
                [options]="{type: 'text', icon: 'filter', onClick: filterClick}"></dxi-button>
  </dx-text-box>

  <dx-toolbar class="map-sidebar-toolbar">
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: groupToggleIcon, hint: 'Afficher/Cacher', onClick: groupsToggle}"></dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: 'refresh', hint: 'Recharger', onClick: refreshGrid}"></dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: 'search', hint: 'Recherche', onClick: toggleSearch}">
    </dxi-item>
  </dx-toolbar>

  <dx-data-grid
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    [errorRowEnabled]="false"
    [showColumnHeaders]="false"
    [hoverStateEnabled]="true"
    [activeStateEnabled]="true"
    [remoteOperations]="{ grouping: false, filtering: false, sorting: false, paging: false, summary: false}"
    [repaintChangesOnly]="true"
    (onRowExpanded)="onRowExpanded($event)"
    (onRowCollapsed)="onRowCollapsed($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onRowClick)="onRowClick($event)"
    (onContentReady)="onGridContentReady($event)"
    [columnAutoWidth]="true">

    <dxo-grouping expandMode="rowClick" [autoExpandAll]="groupExpanded"></dxo-grouping>

    <dxi-column dataField="name" dataType="string" alignment="left" cellTemplate="cellTemplate">
      <div *dxTemplate="let cell of 'cellTemplate'">
        <div #item class="flex flex-row flex-wrap w-full">
          <div style="width: 36px; height: 36px;"
               class="text-center bg-gray-100 self-center rounded-full h-9 w-9 m-2 relative item-icon">
            <!--<i class="dx-icon-ld-status"></i>-->
            <span title="Changer l'icon" (click)="changeIcon($event, cell.data)" [ngSwitch]="cell.data.tracker.state()">
                    <img *ngSwitchCase="1"
                         [src]="domSanitizer.bypassSecurityTrustResourceUrl(cell.data.settings.getTrackerStateIconUrl('moving', 'assets/icons/tractor-green.svg'))"/>
                    <img *ngSwitchCase="2"
                         [src]="domSanitizer.bypassSecurityTrustResourceUrl(cell.data.settings.getTrackerStateIconUrl('idle', 'assets/icons/tractor-orange.svg'))"/>
                    <img *ngSwitchCase="3"
                         [src]="domSanitizer.bypassSecurityTrustResourceUrl(cell.data.settings.getTrackerStateIconUrl('default', 'assets/icons/tractor-red.svg'))"/>
                    <img *ngSwitchCase="4"
                         [src]="domSanitizer.bypassSecurityTrustResourceUrl(cell.data.settings.getTrackerStateIconUrl('offline', 'assets/icons/tractor-gray.svg'))"/>
                </span>
          </div>

          <div class="m-2">
            <span class="text-gray-700 text-sm block font-normal uppercase mb-1 item-title">{{cell.data.name}}</span>
            <div>
              <div *ngIf="cell.data.tracker.tracker_time; else noTime" class="flex items-center text-xs text-gray-500">
                <span [attr.id]="'tracker-state-'+cell.data.id" class="state-icon" (mouseenter)="showTrackerStateTooltip($event, cell.data)" [ngClass]="isTractorConnected(cell.data.tracker.tracker_time) ? 'state-connected' : 'state-disconnected'" >
                  <svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <g>
                      <path d="M256,76.2c-95.7,0-185.9,37.4-253.7,105.3c-3,3-3,7.9,0,10.9l50.9,50.9c1.4,1.4,3.4,2.3,5.5,2.3
                        c2,0,4-0.8,5.5-2.3c51.3-51.3,119.5-79.6,191.9-79.6c72.4,0,140.6,28.3,191.9,79.6c1.4,1.4,3.4,2.3,5.5,2.3s4-0.8,5.5-2.3
                        l50.9-50.9c1.4-1.4,2.3-3.4,2.3-5.5c0-2-0.8-4-2.3-5.5C441.9,113.6,351.7,76.2,256,76.2z"/>
                      <path d="M256,211.3c-59.7,0-115.9,23.3-158.2,65.6c-1.4,1.4-2.3,3.4-2.3,5.5c0,2,0.8,4,2.3,5.5l50.9,50.9
                        c1.4,1.4,3.4,2.3,5.5,2.3c2,0,4-0.8,5.5-2.3c25.8-25.8,60-40,96.4-40s70.6,14.2,96.4,40c1.4,1.4,3.4,2.3,5.5,2.3c2,0,4-0.8,5.5-2.3
                        l50.9-50.9c3-3,3-7.9,0-10.9C371.9,234.6,315.7,211.3,256,211.3z"/>
                      <path d="M256,354.5c-20.9,0-40.5,8.1-55.2,22.9c-3,3-3,7.9,0,10.9l49.8,49.8c1.4,1.4,3.4,2.3,5.5,2.3s4-0.8,5.5-2.3
                        l49.8-49.8c3-3,3-7.9,0-10.9C296.5,362.6,276.9,354.5,256,354.5z"/>
                    </g>
                  </svg>
                </span>
                <p class="px-1">•</p>
                <span [attr.id]="'tracker-card-'+cell.data.id" class="state-icon" (mouseenter)="showTrackerCardTooltip($event, cell.data)"  [ngClass]="(cell.data.tracker.params.BCEBeaconID || cell.data.tracker.params.BLEBeaconID || cell.data.tracker.params.RFID != 0) ? 'state-connected' : 'state-disconnected'" >
                  <svg *ngIf="cell.data.tracker.params.BCEBeaconID || cell.data.tracker.params.BLEBeaconID; else rfidCardIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.71 7.71L12 2v7.59L7.41 5 6 6.41 11.59 12 6 17.59 7.41 19 12 14.41V22l5.71-5.71L13.41 12l4.3-4.29zM14 6.83l.88.88-.88.88V6.83zm.88 9.46-.88.88v-1.76l.88.88z"/>
                  </svg>
                  <ng-template #rfidCardIcon>
                    <svg viewBox="339.218 99.863 44 30" xmlns="http://www.w3.org/2000/svg">
                      <path d="M 230.023 143.472 L 230.023 144.626 L 186.023 144.626 L 186.023 143.626 C 186.023 141.626 187.947 138.626 191.023 138.626 C 195.626 138.626 225.023 138.626 225.023 138.626 C 227.572 138.626 230.023 140.925 230.023 143.472 Z M 230.023 164.01 C 230.023 166.56 227.956 168.626 225.407 168.626 L 190.639 168.626 C 188.089 168.626 186.023 166.56 186.023 164.01 L 186.023 149.626 L 230.023 149.626 Z" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" transform="matrix(1, 0, 0, 1, 153.194809, -38.763336)"/>
                    </svg>
                  </ng-template>
                </span>
                <p class="px-1">•</p>
                <span [attr.id]="'tracker-switch-'+cell.data.id" class="state-icon" (mouseenter)="showTrackerSwitchTooltip($event, cell.data)"  [ngClass]="(cell.data.tracker.params.IN2 == 0) ? 'state-disconnected' : 'state-connected'" >
                  <svg viewBox="218.408 300.004 205.321 204.394" xmlns="http://www.w3.org/2000/svg">
                    <path d="M 398.624 401.243 C 398.624 444.081 363.9 478.798 321.069 478.798 C 278.237 478.798 243.513 444.081 243.513 401.243 C 243.513 364.264 269.406 333.36 304.05 325.604 L 304.05 372.146 C 304.028 372.51 304.017 372.877 304.017 373.247 C 304.017 383.232 312.111 391.326 322.096 391.326 C 332.081 391.326 340.175 383.232 340.175 373.247 C 340.175 373.077 340.173 372.908 340.168 372.739 L 340.168 326.101 C 373.762 334.606 398.624 365.008 398.624 401.243 Z" transform="matrix(0.906308, 0.422618, -0.422618, 0.906308, 200.059128, -98.006317)"/>
                  </svg>
                </span>
                <p *ngIf="cell.data.tracker.speed > 0" class="px-1">•</p>
                <p *ngIf="cell.data.tracker.speed > 0">{{cell.data.tracker.speed}} km/h</p>

              </div>

              <ng-template #noTime><p class="text-xs text-gray-500">Indisponible</p></ng-template>
            </div>
          </div>

          <div class="text-center m-2 ml-auto self-center">
            <div *ngIf="cell.data.interventionStatus" class="flex flex-wrap">
              <lib-badge (mouseenter)="showInterventionPopover($event, cell.data)"
                         [attr.id]="'tractor-badge-'+cell.data.id"
                         [dotColor]="cell.data.interventionStatus.stateColor"
                         color="gray" [showDot]="true">
              <span title="{{cell.data.interventionStatus.trailer_name}} {{cell.data.interventionStatus.field_name}}"
                    class="capitalize block">{{cell.data.interventionStatus.stateText}}</span>
              </lib-badge>
            </div>
          </div>
        </div>
        <dx-context-menu
          [dataSource]="[{imei: cell.data.tracker.imei, text: 'Historique', action: 'history', icon:'map'},
        {text: 'Consommation Carburant', action: 'fuel-realtime-consumption', icon:'fill', visible: cell.data.tracker.hasFlowMeter()}]"
          [width]="100"
          (onItemClick)="contextMenuClick($event, cell.data)"
          [target]="item">
          <div class="text-gray-700 text-sm" *dxTemplate="let m of 'item'; let i = index">
            <span class="text-base dx-icon-{{m.icon}}"></span>
            <span class="ml-2">{{m.text}}</span>
          </div>
        </dx-context-menu>

        <app-fuel-realtime-consumption-popup *ngIf="fuelRealtimeConsumptionPopups[cell.data.tracker.imei]" [name]="cell.data.name"
                                             [tracker]="cell.data.tracker"
                                             [width]="700"
                                             [height]="580"
                                             [(visible)]="fuelRealtimeConsumptionPopups[cell.data.tracker.imei]"></app-fuel-realtime-consumption-popup>
      </div>
    </dxi-column>

    <dxi-column dataType="string"
                alignment="left"
                name="domain_name"
                dataField="domain_name"
                groupCellTemplate="domainGroupTemplate"
                [formItem]="{visible: false}"
                [visible]="false">
      <app-map-sidebar-group-header *dxTemplate="let group of 'domainGroupTemplate'" [group]="group"></app-map-sidebar-group-header>
    </dxi-column>

    <dxi-column dataType="string"
                alignment="left"
                name="business_unit_name"
                dataField="business_unit_name"
                groupCellTemplate="buGroupTemplate"
                [formItem]="{visible: false}"
                [visible]="false">
      <app-map-sidebar-group-header *dxTemplate="let group of 'buGroupTemplate'" [group]="group"></app-map-sidebar-group-header>
    </dxi-column>

    <dxo-summary>
      <dxi-group-item
        column="name"
        summaryType="count">
      </dxi-group-item>
    </dxo-summary>
  </dx-data-grid>
</app-tab>


<app-vehicles-icon-selector></app-vehicles-icon-selector>

<dx-tooltip
    showEvent="dxhoverstart"
    position="right"
    hideEvent="dxhoverend">
    <div *dxTemplate="let model of 'content'">
        <p *ngIf="tooltipData" [innerHTML]="tooltipData"></p>
    </div>
</dx-tooltip>

<dx-popover
  class="intervention-popover"
  [width]="700"
  [showTitle]="true"
  [elementAttr]="{class: 'intervention-popover'}"
  position="right"
  [title]="'Intervention ' + interventionTractor?.interventionStatus?.trailer_operation_name + ' ' + interventionTractor?.name"
  [showCloseButton]="true">
  <div *dxTemplate="let model of 'content'">
    <div *ngIf="interventionTractor.interventionStatus" #item class="flex flex-row w-full">
      <div>
        <div class="details-list">
          <div>Etat</div>
          <div
            class="bg-{{interventionTractor.interventionStatus.stateColor}}-100">{{interventionTractor.interventionStatus.stateText}}</div>
          <div>Outils</div>
          <div>{{interventionTractor.interventionStatus.trailer_name}}</div>
          <div>Durée</div>
          <div>{{interventionTractor.interventionStatus.startAgo}}</div>
          <div>Date Début</div>
          <div>{{interventionTractor.interventionStatus.start_time  | date:'yyyy-MM-dd HH:mm:ss'}}</div>
          <div>Date Fin</div>
          <div>{{interventionTractor.interventionStatus.stop_time  | date:'yyyy-MM-dd HH:mm:ss'}}</div>
        </div>

        <div *ngIf="interventionField" class="details-list">
          <div>Superficie</div>
          <div>{{interventionTractor.interventionStatus.workingAreaHa}}
            ({{interventionTractor.interventionStatus.workingAreaPercent}})
          </div>
        </div>
      </div>
      <div>
        <div class="details-list">
          <div>Durée Totale</div>
          <div [innerHTML]="interventionTractor.interventionStatus.durationHTML('total_duration')"></div>
          <div>Totale Travail</div>
          <div [innerHTML]="interventionTractor.interventionStatus.durationHTML('total_working_duration')"></div>
          <div>Arrêt Travail</div>
          <div [innerHTML]="interventionTractor.interventionStatus.durationHTML('stop_working_duration')"></div>
          <div>Totale Trajet</div>
          <div [innerHTML]="interventionTractor.interventionStatus.durationHTML('total_road_duration')"></div>
        </div>
      </div>
      <div class="ml-2" *ngIf="interventionField">
        <span class="text-gray-700 text-sm block font-normal uppercase mb-1">{{interventionField.name}}</span>
        <lib-field-svg [width]="110" [height]="110" [field]="interventionField" [strokeWidth]="1"></lib-field-svg>
      </div>
    </div>
  </div>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{ text: 'Suivre',
    hint: 'Suivre sur la carte',
     stylingMode: 'text',
  type: 'default',
  onClick: startFollowIntervention }">
  </dxi-toolbar-item>
</dx-popover>

<app-map-intervention-popup [status]="interventionTractor?.interventionStatus" [tractor]="interventionTractor"
                            [intervention]="followInter"
                            (onClose)="stopFollowIntervention()"></app-map-intervention-popup>
